import React, { useState, useEffect } from 'react';
import { Grid, Typography, Paper, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { useTheme } from '@mui/system';
import MainCard from 'components/Cards/MainCard';
import { gridSpacing } from 'utils/constants';
import ReportFileExports from 'components/Reports/FileExports';

const ManagementDevicesTISData = () => {
    const theme = useTheme();
    const [devicesTISData, setDevicesTISData] = useState([]);

    useEffect(() => {
        getTISData();
    }, []);

    const getTISData = () => {
        setDevicesTISData(JSON.parse(localStorage.getItem('devicesTISData')));
        localStorage.removeItem('devicesTISData');
    };

    return (
        <MainCard title="Device Management" cardHeaderTitle="Show TIS Data" cardHeaderShow={true}>
            <Grid container spacing={gridSpacing}>
                {devicesTISData.length > 0 && (
                    <Grid item xs={12}>
                        <ReportFileExports
                            elementId="deviceTISData"
                            reportTitle="Devices TIS Data"
                            downloadFileName="devices_tis_data"
                            downloadFileOption="all"
                            data={devicesTISData}
                            headers={[
                                { label: 'Device Name', key: 'name' },
                                { label: 'CPU On', key: 'cpu_on' },
                                { label: 'Display On', key: 'disp_on' },
                                { label: 'Act On', key: 'act_on' },
                                { label: 'IP Address', key: 'ipaddress' },
                                { label: 'Interval End', key: 'intervalend' },
                                { label: 'UTC Offset', key: 'utcoffset' },
                                { label: 'Time Interval', key: 'timeinterval' },
                                { label: 'Battery Capacity', key: 'batterycap' },
                                { label: 'Battery Charge', key: 'batterycharge' },
                                { label: 'State', key: 'thestate' },
                                { label: 'Watts', key: 'watts' },
                                { label: 'Latitude', key: 'latitude' },
                                { label: 'Longitude', key: 'longitude' }
                            ]}
                            filtersData={[]}
                        />
                    </Grid>
                )}
                <Grid item xs={12}>
                    <Paper sx={{ overflowX: 'auto' }}>
                        {devicesTISData.length === 0 ? (
                            <Typography sx={{ textAlign: 'center', mt: 3 }} color={theme.palette.secondary.main}>
                                No data to show the devices time-in-state data
                            </Typography>
                        ) : (
                            <Table id="deviceTISData">
                                <TableHead>
                                    <TableRow>
                                        <TableCell width="10%">Device Name</TableCell>
                                        <TableCell>CPU On</TableCell>
                                        <TableCell>Display On</TableCell>
                                        <TableCell>Act On</TableCell>
                                        <TableCell width="10%">IP Address</TableCell>
                                        <TableCell>Interval End</TableCell>
                                        <TableCell>UTC Offset</TableCell>
                                        <TableCell>Time Interval</TableCell>
                                        <TableCell>Battery Capacity</TableCell>
                                        <TableCell>Battery Charge</TableCell>
                                        <TableCell>State</TableCell>
                                        <TableCell>Watts</TableCell>
                                        <TableCell>Latitude</TableCell>
                                        <TableCell>Longitude</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {devicesTISData.map((data, key) => (
                                        <TableRow key={key}>
                                            <TableCell>{data.name}</TableCell>
                                            <TableCell>{data.cpu_on}</TableCell>
                                            <TableCell>{data.disp_on}</TableCell>
                                            <TableCell>{data.act_on}</TableCell>
                                            <TableCell>{data.ipaddress}</TableCell>
                                            <TableCell>{data.intervalend}</TableCell>
                                            <TableCell>{data.utcoffset}</TableCell>
                                            <TableCell>{data.timeinterval}</TableCell>
                                            <TableCell>{data.batterycap}</TableCell>
                                            <TableCell>{data.batterycharge}</TableCell>
                                            <TableCell>{data.thestate}</TableCell>
                                            <TableCell>{data.watts}</TableCell>
                                            <TableCell>{data.latitude}</TableCell>
                                            <TableCell>{data.longitude}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        )}
                    </Paper>
                </Grid>
            </Grid>
        </MainCard>
    );
};

export default ManagementDevicesTISData;
